import { render, staticRenderFns } from "./DesignDetail.vue?vue&type=template&id=52643dca&scoped=true"
import script from "./DesignDetail.vue?vue&type=script&lang=js"
export * from "./DesignDetail.vue?vue&type=script&lang=js"
import style0 from "./DesignDetail.vue?vue&type=style&index=0&id=52643dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52643dca",
  null
  
)

export default component.exports